export type BetBuilderOdd = {
    outcomeId: string;
    marketUuid: string;
    uuid: string;
    name: string;
    description: string;
    displayValue: string;
    price: number;
    status: BetBuilderOddStatus;
    specialBetValue: string;
    specifiers?: Record<string, string>;
};

export const BetBuilderOddStatus = {
    Active: 'ACTIVE',
    Blocked: 'BLOCKED',
    Unavailable: 'UNAVAILABLE',
} as const;
export type BetBuilderOddStatus = typeof BetBuilderOddStatus[keyof typeof BetBuilderOddStatus];
